import styled, { css, keyframes } from "styled-components";

const divStyleOnlyProps = new Set([
  "primary",
  "transparent",
  "loader",
  "loading",
  "onscroll",
  "loaderAlign",
  "scroll",
  "issmallscreen", 
]);

const shouldForwardDivProp = prop => !divStyleOnlyProps.has(prop);

const rounded = css`
  border-radius: 5px;
`;
const margin24 = `24px`;
const margin12 = `12px`;

export const fluidHeader = css`
  position: absolute;
  top: 0;
  left: 0;
  height: 60px;
  margin: 0px;
`;

export const UIWidgetsDiv = styled.div.withConfig({
  shouldForwardProp: shouldForwardDivProp,
})`
  font: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: ${props => (props.primary ? "none" : props.theme.baseBorderColor)};
  background-color: ${props =>
    props.primary
      ? props.theme.lightGrayBlue
      : props.transparent
      ? props.theme.transparent
      : props.theme.brandWhite};
  color: ${props =>
    props.primary ? props.theme.altFontColor : props.theme.baseFontColor};
  width: ${props => (props.width ? props.width : "100%")};
  height: ${props => (props.height ? props.height : "auto")};
  box-sizing: border-box;
  position: ${props =>
    props.loading &&
    !(
      props.onscroll &&
      (props.loaderAlign === "top" || props.loaderAlign === "bottom")
    ) &&
    "relative"};
  opacity: ${props => props.loading && "0.7"};
  ${props => props.loading && UIWidgetsDivLoader(props)};
`;

export const UIWidgetsFlex = styled(UIWidgetsDiv).withConfig({
  shouldForwardProp: shouldForwardDivProp,
})`
  flex-direction: row;
`;

export const UIWidgetsDivGrid = styled.div.withConfig({
  shouldForwardProp: shouldForwardDivProp,
})`
  font: inherit;
  border: ${props => (props.primary ? "none" : props.theme.baseBorderColor)};
  background-color: ${props => props.theme.gridBackColor};
  width: 100%;
  height: 20vh;
  text-align: center;
  position: relative;
  z-index: 999999;
  top: 0;
  right: 0;
`;

export const UIWidgetsDivGridWrapper = styled.div.withConfig({
  shouldForwardProp: shouldForwardDivProp,
})`
  font: inherit;
  width: 100%;
  height: 20vh;
  position: static;
  top: 0px;
  left: 0px;
  z-index: 1000000;
  opacity: 0.4;
`;

export const UIWidgetsDivRound = styled(UIWidgetsDiv).withConfig({
  shouldForwardProp: shouldForwardDivProp,
})`
  ${rounded}
`;

export const UIWidgetsDivStretch = styled(UIWidgetsDiv).withConfig({
  shouldForwardProp: shouldForwardDivProp,
})`
  display: flex;
  flex-direction: column;
  & > div:last-child {
    flex: 1;
  }
`;

export const UIWidgetDivider = styled.span`
  border: none;
  color: white;
  height: 1px !important;
  width: 100% !important;
  opacity: 0.5;
  background: ${props => props.theme.brandBlue};
  background: -webkit-gradient(
    radial,
    50% 50%,
    0,
    50% 50%,
    100,
    from(${props => props.theme.brandBlue}),
    to(#fff)
  );
`;

const LoaderKeyFrames = keyframes`
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
`;

const UIWidgetsDivLoader = params => {
  let top =
    params.scroll && params.loaderAlign
      ? params.scroll - 50 + "px"
      : params.loaderAlign === "top"
      ? "30%"
      : params.loaderAlign === "bottom"
      ? "70%"
      : "50%";

  return css`
 &:before {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #ffc20e;
  width: 35px;
  height: 35px;
  animation: ${LoaderKeyFrames} 1s linear infinite;
  position: absolute;
  z-index: 9999999999;
  top: ${top};
  left: 49.5%;
  content:"";
  display: grid;
  opacity:1;
 }
`;
};
